import {ChecksMiniStatus, ChecksMiniStatusBoundary} from './mini-merge-sections/ChecksMiniStatus'
import {ApprovalsMiniStatus, ApprovalsMiniStatusBoundary} from './mini-merge-sections/ApprovalsMiniStatus'
import {CommentsMiniStatus, CommentsMiniStatusBoundary} from './mini-merge-sections/CommentsMiniStatus'
import {Stack} from '@primer/react'
import {usePullRequestState} from '../../../../hooks/use-pull-request-state'

export function MiniOverviewMergeStatus() {
  const state = usePullRequestState()

  if (state === 'MERGED' || state === 'CLOSED') {
    return null
  }

  return (
    <Stack as="section" direction={{narrow: 'vertical', regular: 'horizontal'}} gap="none" aria-label="Merge status">
      <ChecksMiniStatusBoundary>
        <ChecksMiniStatus />
      </ChecksMiniStatusBoundary>

      <CommentsMiniStatusBoundary>
        <CommentsMiniStatus />
      </CommentsMiniStatusBoundary>

      <ApprovalsMiniStatusBoundary>
        <ApprovalsMiniStatus />
      </ApprovalsMiniStatusBoundary>
    </Stack>
  )
}
